import type { Variants } from 'motion/react'

export const TOPBAR_BG_COLOR = 'var(--appearance-1)'

export const TOPBAR_POSITIONS_VARIANTS: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  },
}
